import { CommonModule, CurrencyPipe, DatePipe } from '@angular/common';
import { NgModule } from '@angular/core';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { CalendarModule } from 'primeng/calendar';
import { ChartModule } from 'primeng/chart';
import { DialogModule } from 'primeng/dialog';
import { DropdownModule } from 'primeng/dropdown';
import { DialogService } from 'primeng/dynamicdialog';
import { FieldsetModule } from 'primeng/fieldset';
import { MultiSelectModule } from 'primeng/multiselect';
import { TableModule } from 'primeng/table';
import { TabViewModule } from 'primeng/tabview';
import { ToastModule } from 'primeng/toast';
import { TooltipModule } from 'primeng/tooltip';
import { CouponsReportModule } from 'src/app/components/coupons-report/coupons-report.module';
import { DashboardCardComponent } from 'src/app/components/dashboard-card/dashboard-card.component';
import { DashboardFooterComponent } from 'src/app/components/dashboard-footer/dashboard-footer.component';
import { DashboardHeaderComponent } from 'src/app/components/dashboard-header/dashboard-header.component';
import { EmailMarketingFormModule } from 'src/app/components/email-marketing-form/email-marketing-form.module';
import { SubscriberGroupCounterChartModule } from 'src/app/components/subscriber-group-counter-chart/subscriber-group-counter-chart.module';
import { AppTableModule } from 'src/app/components/table/app-table.module';
import { ValueChangeModule } from 'src/app/directives/value-change/value-change.module';
import { EditionImageModule } from 'src/app/edition-image/edition-image.module';
import { AcquisitionDashboardComponent } from './acquisition-dashboard/acquisition-dashboard.component';
import { AnalyticsDashboardComponent } from './analytics-dashboard/analytics-dashboard.component';
import { ConsolidatedDashboardComponent } from './consolidated-dashboard/consolidated-dashboard.component';
import { CouponsDashboardComponent } from './coupons-dashboard/coupons-dashboard.component';
import { CrmDashboardComponent } from './crm-dashboard/crm-dashboard.component';
import { EmailListComponent } from './crm-dashboard/email-list/email-list.component';
import { DashboardsRoutingModule } from './dashboards-routing.module';
import { DeliveryDashboardComponent } from './delivery-dashboard/delivery-dashboard.component';
import { IncomeDashboardComponent } from './income-dashboard/income-dashboard.component';
import { InvoicesDashboardComponent } from './invoices-dashboard/invoices-dashboard.component';
import { EditionRatingAndScoresDashboardComponent } from './rating-and-scores-dashboard/edition-rating-and-scores-dashboard/edition-rating-and-scores-dashboard.component';
import { RatingAndScoresDashboardComponent } from './rating-and-scores-dashboard/rating-and-scores-dashboard.component';
import { SubscriptionsDashboardComponent } from './subscriptions-dashboard/subscriptions-dashboard.component';
import { UpgradeDowngradeDashboardComponent } from './upgrade-downgrade-dashboard/upgrade-downgrade-dashboard.component';
import { WishlistDashboardComponent } from './wishlist-dashboard/wishlist-dashboard.component';

@NgModule({
  declarations: [
    AcquisitionDashboardComponent,
    IncomeDashboardComponent,
    SubscriptionsDashboardComponent,
    CouponsDashboardComponent,
    RatingAndScoresDashboardComponent,
    EditionRatingAndScoresDashboardComponent,
    UpgradeDowngradeDashboardComponent,
    DeliveryDashboardComponent,
    AnalyticsDashboardComponent,
    WishlistDashboardComponent,
    ConsolidatedDashboardComponent,
    InvoicesDashboardComponent,
    CrmDashboardComponent,
    EmailListComponent,
    DashboardHeaderComponent,
    DashboardFooterComponent,
    DashboardCardComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    DropdownModule,
    ButtonModule,
    TooltipModule,
    TableModule,
    TabViewModule,
    SubscriberGroupCounterChartModule,
    DashboardsRoutingModule,
    EditionImageModule,
    ChartModule,
    CouponsReportModule,
    AppTableModule,
    ToastModule,
    ValueChangeModule,
    CalendarModule,
    FormsModule,
    DialogModule,
    FieldsetModule,
    EmailMarketingFormModule,
    MultiSelectModule
  ],
  exports: [AnalyticsDashboardComponent, ConsolidatedDashboardComponent],
  providers: [CurrencyPipe, CurrencyPipe, DialogService, DatePipe]
})
export class DashboardsModule {}
